function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#f4f4f4",
  d: "M0 51.5C0 23.057 23.057 0 51.5 0S103 23.057 103 51.5 79.943 103 51.5 103 0 79.943 0 51.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#464a55",
  d: "M66 34.698l-1.389 37.52c-.024.645-.59 1.19-1.238 1.19h-24.01c-.645 0-1.213-.548-1.237-1.19l-1.39-37.52a1.876 1.876 0 0 0-3.748.14l1.39 37.52c.098 2.658 2.322 4.802 4.986 4.802h24.01c2.662 0 4.888-2.14 4.986-4.802l1.39-37.52a1.876 1.876 0 0 0-3.75-.14z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#464a55",
  d: "M49.868 42.27v25.51a1.5 1.5 0 1 0 3.001 0V42.27a1.5 1.5 0 1 0-3 0z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#464a55",
  d: "M41.616 42.315l.75 25.51a1.5 1.5 0 1 0 3-.088l-.75-25.51a1.5 1.5 0 1 0-3 .088z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#464a55",
  d: "M58.122 42.227l-.75 25.51a1.5 1.5 0 1 0 3 .088l.75-25.51a1.5 1.5 0 1 0-3-.088z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#464a55",
  d: "M32.611 35.518h37.515a1.875 1.875 0 1 0 0-3.751H32.611a1.875 1.875 0 1 0 0 3.751z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#464a55",
  d: "M45.67 33.032l.78-2.734c.168-.585.926-1.157 1.536-1.157h6.766c.609 0 1.368.571 1.535 1.157l.78 2.734 3.608-1.03-.78-2.734c-.629-2.197-2.86-3.879-5.143-3.879h-6.766c-2.284 0-4.516 1.683-5.143 3.88l-.781 2.733z"
})));

var SvgCloseAccountIcon = function SvgCloseAccountIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseAccountIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-account-icon.acb0af03.svg";
export { ForwardRef as ReactComponent };